// extracted by mini-css-extract-plugin
export default {"iconButton":"styles_iconButton__6hiVZ","xs":"styles_xs__dZLAZ","sm":"styles_sm__bS-X6","md":"styles_md__SJV0a","xl":"styles_xl__B1fgj","disabled":"styles_disabled__P0D42"};